<h1 mat-dialog-title class="bg-slate-700">
  <span class="text-white">Orden Nº : #{{ data.id }}</span>
   <a
     mat-dialog-close
     class="absolute top-1 right-0 p-2.5 text-sm font-medium text-white rounded-r-lg cursor-pointer"
   >
     <svg
       xmlns="http://www.w3.org/2000/svg"
       class="h-6 w-6"
       fill="none"
       viewBox="0 0 24 24"
       stroke="currentColor"
       stroke-width="2"
     >
       <path
         stroke-linecap="round"
         stroke-linejoin="round"
         d="M6 18L18 6M6 6l12 12"
       />
     </svg>
   </a>
 </h1>
 <div mat-dialog-content>
   <div
     class="relative bg-white border shadow-md rounded-2xl p-4 space-y-4 my-4 lg:justify-between"
   >
     <div class="flex-none sm:flex items-center">
       <div class="relative h-12 w-12 sm:mb-0 mb-3">
         <svg
           xmlns="http://www.w3.org/2000/svg"
           viewBox="0 0 24 24"
           fill="currentColor"
           class="w-12 h-12 object-cover rounded-2xl text-gray-400"
         >
           <path
             fill-rule="evenodd"
             d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z"
             clip-rule="evenodd"
           />
         </svg>
       </div>
       <div class="flex-auto sm:ml-5 justify-evenly">
         <div class="flex items-center justify-between sm:mt-2">
           <div class="flex items-center">
             <div class="flex flex-col">
               <p
                 class="text-ellipsis flex-wrap truncate text-2xl text-gray-900 font-bold hidden lg:flex"
                 style="text-overflow: ellipsis !important"
               >
                 {{ orden.contract.client_name || '' }}
               </p>
               <div class="flex-col lg:hidden flex-wrap">
                 <p class="text-2xl text-gray-900 font-bold">
                   {{ orden.contract.client_name_name || '' }}
                 </p>
                 <br />
                 <p class="text-2xl text-gray-900 font-bold mt-[-30px]">
                   {{ orden.contract.client_name_lastname || ''}}
                 </p>
               </div>
               <div class="flex-auto text-gray-400 my-1">
                 <span class="mr-3">{{ orden.contract.identification || ''}}</span>
               </div>
             </div>
           </div>
         </div>
         <div class="flex flex-row items-center">
           <div class="">
             <p class="text-lg">
               Nro de contrato:
               <span class="font-semibold"
                 >{{ orden.contract.id }}
                 <button
                   type="button"
                   class="group relative h-4 w-4 rounded-fill hover:bg-gray-500/20 text-gray-500"
                   (click)="copyToClipboard(orden.contract.id.toString())"
                 >
                   <span class="sr-only">Copy</span>
                   <svg
                     xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 20 20"
                     fill="currentColor"
                   >
                     <path
                       d="M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z"
                     />
                     <path
                       d="M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z"
                     />
                   </svg>
                   <span class="absolute -inset-1"></span>
                 </button>
               </span>
             </p>
           </div>
           <div class="flex-1 inline-flex items-center ml-2 space-x-2"></div>
         </div>
         <div class="flex flex-row gap-4 items-center">
           <p class="text-sm text-gray-600 font-bold mt-[-30px]">
             Tipo de plan: {{ orden.contract.plan_name_internet || '' }}
           </p>
         </div>
         <div class="flex-none pt-4">
           <dt class="sr-only">Status</dt>
           <dd
             class="inline-flex items-center rounded-md  {{
               data.confirmation
                 ? ' bg-green-50  text-green-700  ring-green-600/20'
                 : 'bg-gray-300  text-gray-700  ring-gary-600/20'
             }} px-2 py-1 text-xs font-medium ring-inset"
           >
             {{ data.confirmation ? "Confirmado" : "Sin confirmar" }}
           </dd>
         </div>
       </div>
     </div>
     <div class="absolute bottom-2 right-2">
       <button
       (click)="sendConfirmation()"
         mat-mini-fab
         matTooltip="Enviar confirmación de orden"
         color="accent"
       >
         <mat-icon>mark_email_read</mat-icon>
       </button>
     </div>
   </div>
   <div class="flex flex-col p-4 bg-white shadow-lg rounded-2xl">
     <ul class="mt-2 space-y-2">
       <li class="flex items-center justify-between">
         <span class="font-semibold w-24">Correo electrónico:</span>
         <span class="text-gray-700">{{ orden.client.email }}</span>
       </li>
       <li class="flex items-center justify-between">
         <span class="font-semibold w-24">Teléfono principal:</span>
         <span class="text-gray-700">{{ orden.client.mobile }}</span>
       </li>
       <li class="flex items-center justify-between">
         <span class="font-semibold w-24">Teléfono secundario:</span>
         <span class="text-gray-700">{{ orden.client.phone }}</span>
       </li>

       <li class="flex items-center justify-between">
         <span class="font-semibold w-24 mr-5">Ubicación de instalación:</span>
         <span class="text-gray-700">{{
           orden.contract.address | uppercase
         }}</span>
       </li>
       <li class="flex items-center justify-between">
         <span class="font-semibold w-24 mr-5">Estado de Pago:</span>
         <span
           class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-inset"
           [ngClass]="
             !data.payment
               ? 'text-red-600 bg-red-50 '
               : 'text-green-700 bg-green-50'
           "
         >
           {{ data.payment ? "Pagado" : "Pendiente por Pagar" }}
           {{
             data.invoice_payment != null || data.invoice_payment == ""
               ? ""
               : "/ Instalación Gratis"
           }}</span
         >
       </li>
       <li class="flex items-center justify-between">
         <span class="font-semibold w-24 mr-5">Sector:</span>
         <span class="text-gray-700">{{ data.sector_name | uppercase }}</span>
       </li>
       <li class="flex items-center justify-between">
         <span class="font-semibold w-24 mr-5">Caja NAP:</span>
         <span class="text-gray-700">{{ data.nap_box | uppercase }}</span>
       </li>
       <li class="flex items-center justify-between">
         <span class="font-semibold w-24 mr-5">
           Fecha y Hora de instalación:</span
         >
         <span class="text-gray-700"
           ><time datetime="2023-01-31"
             >{{ data.start | date : "dd/MM/yyyy" }} -
             {{ data.end | date : "dd/MM/yyyy" }}</time
           ></span
         >
       </li>
     </ul>
   </div>

   <div
     class="bg-white border shadow-md rounded-2xl p-4 space-y-4 my-4 flex flex-col"
   >
     <div class="flex items-center justify-between sm:mt-2">
       <div class="flex items-center">Observaciones</div>
       <!-- <button mat-mini-fab matTooltip="Agregar detalles" color="primary" (click)="addObservations()" >
         <mat-icon>add_notes</mat-icon>
       </button> -->
     </div>
     <ul class="flex flex-col mt-2 space-y-2">
       <li
         class="flex items-center justify-between"
         *ngFor="let item of orden.order_detail"
       >
         <span class="font-semibold">{{ item.detail }}</span>
         <div class="flex flex-col text-sm">
           <span>{{ item.created_by_name }}</span>
           <span>{{ item.created_at | date : "dd/MM/YYYY, hh:mm a" }}</span>
         </div>
       </li>
     </ul>
   </div>

   <!-- <div class="lg:col-start-3 lg:row-end-1">
     <h2 class="sr-only">Summary</h2>
     <div class="rounded-lg bg-gray-100 shadow-sm ring-1 ring-gray-900/5">
       <dl class="flex flex-wrap">
         <div class="flex-auto pl-6 pt-6">
           <dt class="text-xl font-semibold leading-6 text-gray-900">
             {{ data.order }}
           </dt>
           <dd class="mt-1 text-base font-semibold leading-6 text-gray-900">
             {{ data.client_type_name }}
           </dd>
         </div>
         <div class="flex-none self-end px-6 pt-4">
           <dt class="sr-only">Status</dt>
           <dd
             class="inline-flex items-center rounded-md  {{
               data.confirmation
                 ? ' bg-green-50  text-green-700  ring-green-600/20'
                 : 'bg-gray-300  text-gray-700  ring-gary-600/20'
             }} px-2 py-1 text-xs font-medium ring-inset"
           >
             {{ data.confirmation ? "Confirmado" : "Sin confirmar" }}
           </dd>
         </div>
         <div
           class="mt-6 flex w-full flex-none gap-x-4 border-t border-gray-900/5 px-6 pt-6"
         >
           <dt class="flex-none">
             <span class="sr-only">Client</span>
             <svg
               class="h-6 w-5 text-gray-400"
               viewBox="0 0 20 20"
               fill="currentColor"
               aria-hidden="true"
             >
               <path
                 fill-rule="evenodd"
                 d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-5.5-2.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM10 12a5.99 5.99 0 00-4.793 2.39A6.483 6.483 0 0010 16.5a6.483 6.483 0 004.793-2.11A5.99 5.99 0 0010 12z"
                 clip-rule="evenodd"
               />
             </svg>
           </dt>
           <dd class="text-sm font-medium leading-6 text-gray-900">
             {{ data.client_name }}
           </dd>
         </div>
         <div class="mt-6 flex w-full flex-none gap-x-4 px-6">
           <dt class="flex-none">
             <span class="sr-only">Client</span>
             <svg
               class="h-6 w-5 text-gray-400"
               viewBox="0 0 20 20"
               fill="currentColor"
               aria-hidden="true"
             >
               <path
                 fill-rule="evenodd"
                 d="M10 2a1 1 0 00-1 1v1a1 1 0 002 0V3a1 1 0 00-1-1zM4 4h3a3 3 0 006 0h3a2 2 0 012 2v9a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2zm2.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm2.45 4a2.5 2.5 0 10-4.9 0h4.9zM12 9a1 1 0 100 2h3a1 1 0 100-2h-3zm-1 4a1 1 0 011-1h2a1 1 0 110 2h-2a1 1 0 01-1-1z"
                 clip-rule="evenodd"
               />
             </svg>
           </dt>
           <dd class="text-sm leading-6 text-gray-900">
             {{ data.client_identification }}
           </dd>
           <dd></dd>
         </div>

         <div class="mt-6 flex w-full flex-none gap-x-4 px-6">
           <dt class="flex-none">
             <span class="sr-only">Phone</span>
             <svg
               class="h-6 w-5 text-gray-400"
               viewBox="0 0 20 20"
               fill="currentColor"
             >
               <path
                 d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
               />
             </svg>
           </dt>
           <dd class="text-sm leading-6 text-gray-900">
             {{ orden.client.phone }} / {{ orden.client.mobile }}
           </dd>
           <dd></dd>
         </div>

         <div class="mt-4 flex w-full flex-none gap-x-4 px-6">
           <dt class="flex-none">
             <span class="sr-only">Due date</span>
             <svg
               class="h-6 w-5 text-gray-400"
               viewBox="0 0 20 20"
               fill="currentColor"
               aria-hidden="true"
             >
               <path
                 d="M5.25 12a.75.75 0 01.75-.75h.01a.75.75 0 01.75.75v.01a.75.75 0 01-.75.75H6a.75.75 0 01-.75-.75V12zM6 13.25a.75.75 0 00-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 00.75-.75V14a.75.75 0 00-.75-.75H6zM7.25 12a.75.75 0 01.75-.75h.01a.75.75 0 01.75.75v.01a.75.75 0 01-.75.75H8a.75.75 0 01-.75-.75V12zM8 13.25a.75.75 0 00-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 00.75-.75V14a.75.75 0 00-.75-.75H8zM9.25 10a.75.75 0 01.75-.75h.01a.75.75 0 01.75.75v.01a.75.75 0 01-.75.75H10a.75.75 0 01-.75-.75V10zM10 11.25a.75.75 0 00-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 00.75-.75V12a.75.75 0 00-.75-.75H10zM9.25 14a.75.75 0 01.75-.75h.01a.75.75 0 01.75.75v.01a.75.75 0 01-.75.75H10a.75.75 0 01-.75-.75V14zM12 9.25a.75.75 0 00-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 00.75-.75V10a.75.75 0 00-.75-.75H12zM11.25 12a.75.75 0 01.75-.75h.01a.75.75 0 01.75.75v.01a.75.75 0 01-.75.75H12a.75.75 0 01-.75-.75V12zM12 13.25a.75.75 0 00-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 00.75-.75V14a.75.75 0 00-.75-.75H12zM13.25 10a.75.75 0 01.75-.75h.01a.75.75 0 01.75.75v.01a.75.75 0 01-.75.75H14a.75.75 0 01-.75-.75V10zM14 11.25a.75.75 0 00-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 00.75-.75V12a.75.75 0 00-.75-.75H14z"
               />
               <path
                 fill-rule="evenodd"
                 d="M5.75 2a.75.75 0 01.75.75V4h7V2.75a.75.75 0 011.5 0V4h.25A2.75 2.75 0 0118 6.75v8.5A2.75 2.75 0 0115.25 18H4.75A2.75 2.75 0 012 15.25v-8.5A2.75 2.75 0 014.75 4H5V2.75A.75.75 0 015.75 2zm-1 5.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H4.75z"
                 clip-rule="evenodd"
               />
             </svg>
           </dt>
           <dd class="text-sm leading-6 text-gray-900">
             <time datetime="2023-01-31"
               >{{ data.start | date : "dd/MM/yyyy" }} -
               {{ data.end | date : "dd/MM/yyyy" }}</time
             >
           </dd>
         </div>
         <div class="mt-4 flex w-full flex-none gap-x-4 px-6">
           <dt class="flex-none">
             <span class="sr-only">Status</span>
             <svg
               class="h-6 w-5 text-gray-400"
               viewBox="0 0 20 20"
               fill="currentColor"
               aria-hidden="true"
             >
               <path
                 fill-rule="evenodd"
                 d="M2.5 4A1.5 1.5 0 001 5.5V6h18v-.5A1.5 1.5 0 0017.5 4h-15zM19 8.5H1v6A1.5 1.5 0 002.5 16h15a1.5 1.5 0 001.5-1.5v-6zM3 13.25a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zm4.75-.75a.75.75 0 000 1.5h3.5a.75.75 0 000-1.5h-3.5z"
                 clip-rule="evenodd"
               />
             </svg>
           </dt>
           <dd
             [ngClass]="
               !data.payment
                 ? 'text-gray-900 text-sm leading-6'
                 : 'text-green-700 ring-green-600/20 text-sm leading-6'
             "
           >
             {{ data.payment ? "Pagado" : "Pendiente por Pagar" }}
             {{
               data.invoice_payment != null || data.invoice_payment == ""
                 ? ""
                 : "/ Instalación Gratis"
             }}
           </dd>
           <dd
             [ngClass]="
               !data.payment
                 ? 'text-gray-900 text-sm leading-6'
                 : 'text-green-700 ring-green-600/20 text-sm leading-6'
             "
           ></dd>
         </div>
         <div class="mt-4 flex w-full flex-none gap-x-4 px-6">
           <dt class="flex-none">
             <span class="sr-only">Address</span>
             <svg
               class="h-6 w-5 text-gray-400"
               viewBox="0 0 20 20"
               fill="currentColor"
               aria-hidden="true"
             >
               <path
                 fill-rule="evenodd"
                 d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                 clip-rule="evenodd"
               />
             </svg>
           </dt>
           <dd class="text-gray-900 text-sm leading-6">
             {{ data.sector_name }}
           </dd>
         </div>
         <div class="mt-4 flex w-full flex-none gap-x-4 px-6">
           <dt class="flex-none">
             <span class="sr-only">Nap</span>
             <mat-icon
               class="h-6 w-5 text-gray-400"
               viewBox="0 0 20 20"
               fill="currentColor"
               aria-hidden="true"
             >
               backpack</mat-icon
             >
           </dt>
           <dd class="text-gray-900 font-medium text-sm leading-6">
             {{ data.nap_box }}
           </dd>
         </div>
       </dl>

     </div>
   </div> -->
 </div>
 <!-- <mat-dialog-actions align="end">
   <button mat-button mat-dialog-close>Cerrar</button>
 </mat-dialog-actions> -->
